jQuery(document).ready(function(){
  // dynamically populate product form with sku and title
  
  jQuery("#order-form-btn").click(function(){
      console.log("click");
      var product_title = jQuery(".product__information .product_name").text().trim();
      console.log(product_title);

      var product_sku = jQuery(".custom_sku").text().trim();
      console.log(product_sku);

      jQuery(".sjfb-field").each(function(){
          var field_check = jQuery(this).find("label").text();
          var field_class = field_check.replace(" ", "_");
          field_class = field_class.replace("/", "_");
          jQuery(this).addClass(field_class);
          var $this = jQuery(this).find("label");
          
          //console.log(field_check);
          if (field_check == "Product Name"){
              jQuery($this).siblings("input").val(product_title);
          }
          else if(field_check == "SKU"){
              jQuery($this).siblings("input").val(product_sku);

          }
      })
  });
      
  
  
  jQuery(".collection_nav__select").on("click", function(){
  	jQuery(this).toggleClass("active");
  });
  
  /*
  if(jQuery(".product-column-row").hasClass("product_hidden")){
	jQuery(".home_main_s_link").hide();
  }else{
	  jQuery(".home-shop-all").hide();
	  jQuery(".home_main_s_link").show();
  }
  */
  jQuery(".home-shop-all").on("click", function(){
	jQuery(".product_hidden").addClass("product_revealed");
	jQuery(".product_revealed").removeClass("product_hidden");
	jQuery(this).hide();
	//jQuery(".home_main_s_link").show();
  });
  
});



// Visitors outside the US get the "Get a Quote" button instead of add-to-cart.
// Country comes from Shopify's visitor detection and is cached for the session.
// If detection fails, add-to-cart stays visible.
(function () {
  var productForms = document.querySelectorAll('.product-form-container');
  var quoteButton = document.getElementById('order-form-btn');
  if (!productForms.length && !quoteButton) return;

  var storageKey = 'bpi_country_code';

  // stylesheet.css forces .product-form-container to display:block !important on product pages.
  function applyCountry(countryCode) {
    if (!countryCode || countryCode === 'US') return;
    if (quoteButton) quoteButton.style.setProperty('display', 'inline-block', 'important');
    for (var i = 0; i < productForms.length; i++) {
      productForms[i].style.setProperty('display', 'none', 'important');
    }
  }

  var cachedCountry = null;
  try { cachedCountry = sessionStorage.getItem(storageKey); } catch (e) {}
  if (cachedCountry) {
    applyCountry(cachedCountry);
    return;
  }

  if (!window.fetch) return;

  fetch('/browsing_context_suggestions.json', { credentials: 'same-origin' })
    .then(function (response) {
      if (!response.ok) throw new Error('Country lookup failed');
      return response.json();
    })
    .then(function (data) {
      var country = data && data.detected_values && data.detected_values.country;
      var countryCode = country && country.handle;
      if (!countryCode) return;
      try { sessionStorage.setItem(storageKey, countryCode); } catch (e) {}
      applyCountry(countryCode);
    })
    .catch(function () {});
})();

/* Cart Page Checkout Button Loading */
jQuery(document).ready(function(){
  jQuery( ".cart__checkout button#checkout" ).click(function() {
    jQuery('.cart__checkout button#checkout').html('<i class="fas fa-spinner fa-pulse"></i>&nbsp;Processing Your Cart');
  });
});
